import { createResourceCollection } from '@/request'
import { Model } from '@/types/model'
import { PlugSession, PlugSessions } from '@/types/plugSessions'

/**
 * GET /api/plug_sessions/ returns a paginated envelope with aggregates
 * (has_rate_plan, total_cost, currency, date range) alongside results.
 * Mirrors chargesCollection: paginationKey 'UNSET' stores the whole envelope
 * as a single resource, so consumers read data[0].
 */
export const plugSessionsCollection = createResourceCollection<
  PlugSessions & Model
>({
  name: 'plugSessions',
  apiConfig: {
    path: 'plug_sessions',
  },
  paginationKey: 'UNSET',
  selector: (state) => state.plugSessions,
})

export const plugSessions = plugSessionsCollection.slice.reducer

/**
 * GET /api/plug_sessions/:id/ returns a single session (queryset is scoped to
 * the authenticated profile — foreign ids 404). Separate collection from the
 * list because the list stores envelopes, not sessions.
 */
export const plugSessionDetailCollection = createResourceCollection<
  PlugSession & Model
>({
  name: 'plugSessionDetails',
  apiConfig: {
    path: 'plug_sessions',
  },
  selector: (state) => state.plugSessionDetails,
})

export const plugSessionDetails = plugSessionDetailCollection.slice.reducer
